// extracted by mini-css-extract-plugin
export default {"format":"AvailableFormat_format__F1gcZ","checkbox":"AvailableFormat_checkbox__N6qky","nameAndPrice":"AvailableFormat_nameAndPrice__s3TMs","from":"AvailableFormat_from__c6P66"};